'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
export default class LoginLoading extends Component {
  render() {
    const {
      message
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: "login-loading",
      children: [/*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true,
        minHeight: 100
      }), /*#__PURE__*/_jsx("h1", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `login.loading.${message}`
        })
      })]
    });
  }

}
LoginLoading.propTypes = {
  message: PropTypes.string
};
LoginLoading.defaultProps = {
  message: 'default'
};